// extracted by mini-css-extract-plugin
module.exports = {"expandicon":"Expand_expandicon__Z4y9p","opened":"Expand_opened__Qwq0E","closed":"Expand_closed__X9FRq"};